import Bounds from './Bounds';

export default function Item(mark) {
  this.mark = mark;
  this.bounds = (this.bounds || new Bounds());
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-scenegraph/src/Item.js
// module id = 309
// module chunks = 0